import React, { useCallback, useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";
import { Container, InputGroup, Input, Button, Table } from 'reactstrap';
import axios from 'axios';
import YangsicDetail from './YangsicDetail';
import stylesCoup from '../Shared/Css/VideosMy/VideosMyListSerche.module.css';

// const defaultEmpVideoSrc = '/empImg/video_placeholder.png'
const defaultEmpVideoExcelSrc = '/empImg/excel_placeholder.png';
const defaultEmpVideoPdflSrc = '/empImg/pdf_placeholder.png';
const defaultEmpVideoTxtlSrc = '/empImg/text_placeholder.png';
const defaultEmpVideo7zSrc = '/empImg/7z.png';
const defaultEmpVideohancomSrc = '/empImg/hancom.png';

function YangsicListSerche() {
  const [yangsicList, setYangsicsList] = useState([]);
  const [randring, setRandring] = useState(false);
  const [yangsicValue, setYangsicValue] = useState(null);
  const [yangsicDetailTrue, setYangsicDetailTrue] = useState(false);
  const [yangsicNameChange, setYangsicNameChange] = useState('');

  //히스토리사용
  const history = useHistory();

  useEffect(() => {
    if (randring === false) {
      setRandring(true);
      refreshYangsicList();
    }
    //경고문 해제
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const headers = useCallback(() => {
    return {
      'Content-type': `text/plain`,
      // headers: { "Content-Type": `multipart/form-data` }
    };
  }, []);

  const yangsicAPI = useCallback(() => {
    const url = '/api/Yangsic/';
    const urlFileDown = '/api/YangsicFileDown/';

    return {
      fetchAll: () => axios.get(url, { params: { yangsicName: yangsicNameChange } }),
      download: (id) => axios.get(urlFileDown + id, { headers }),
    };
  }, [yangsicNameChange, headers]);

  const onDownload = useCallback(
    (e, id) => {
      e.preventDefault();
      if (window.confirm('다운로드를 하겠습니까?'))
        yangsicAPI()
          .download(id)
          .then((res) => {
            const url = res.config.url;
            window.location.href = url; //다운로드 Url
          })
          .catch((err) => console.log(err));
    },
    [yangsicAPI]
  );

  const refreshYangsicList = useCallback(async () => {
    await yangsicAPI()
      .fetchAll()
      .then((res) => {
        setYangsicsList(res.data);
      })
      .catch((err) => console.log(err));
  }, [yangsicAPI]);

  const videoHandle = (e) => {
    setYangsicValue(e.target.src);
    setYangsicDetailTrue(true);
  };

  const handleInputYangsicNameChange = (e) => {
    e.preventDefault();
    setYangsicNameChange(e.target.value);
  };

  const handleInputYangsicNameEnter = (e) => {
    e.preventDefault();
    if (e.key === 'Enter') {
      refreshYangsicList(); // Enter 입력이 되면 클릭 이벤트 실행
    }
  };
  const handleInputYangsicNameChangeQuary = (e) => {
    e.preventDefault();
    refreshYangsicList(); // Enter 입력이 되면 클릭 이벤트 실행
  };

  const yangsicImageCard = useCallback(
    (data) => (
      <div className={`card ${stylesCoup.cardd}`} >
        {data.yangsicImageType === 'image/png' ? (
          <img
            src={data.yangsicImageSrc}
            className={`card-img-top rounded`}
            alt=""
          />
        ) : data.yangsicImageType === 'image/bmp' ? (
          <img src={data.yangsicImageSrc} className="card-img-top rounded" alt="" />
        ) : data.yangsicImageType === 'image/jpeg' ? (
          <img src={data.yangsicImageSrc} className="card-img-top rounded" alt="" />
        ) : data.yangsicImageType === 'image/gif' ? (
          <img src={data.yangsicImageSrc} className="card-img-top rounded" alt="" />
        ) : data.yangsicImageType === 'video/mp4' ? (
          <video
            src={data.yangsicImageSrc}
            controlsList="nodownload"
            className="card-img-top rounded"
            onClick={videoHandle}
          ></video>
        ) : data.yangsicImageType ===
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ? (
          <img
            src={defaultEmpVideoExcelSrc}
            className="card-img-top rounded"
            alt=""
          ></img>
        ) : data.yangsicImageType === 'application/pdf' ? (
          <img
            src={defaultEmpVideoPdflSrc}
            className="card-img-top rounded"
            alt=""
          ></img>
        ) : data.yangsicImageType === 'text/plain' ? (
          <img
            src={defaultEmpVideoTxtlSrc}
            className="card-img-top rounded"
            alt=""
          ></img>
        ) : data.yangsicImageType === 'application/x-zip-compressed' ? (
          <img
            src={defaultEmpVideo7zSrc}
            className="card-img-top rounded"
            alt=""
          ></img>
        ) : data.yangsicImageType === 'application/haansofthwp' ? (
          <img
            src={defaultEmpVideohancomSrc}
            className="card-img-top rounded"
            alt=""
          ></img>
        ) : (
          <img src={data.yangsicImageSrc} className="card-img-top rounded" alt="" />
        )}
        <div className={`card-body pt-1 ${stylesCoup.cardBody}`}>
          <Table bordered size="sm"
            className={`mt-0 mb-0 ${stylesCoup.empTableCard}`}
          >
            <thead>
              <tr>
                <th>파일명</th>
                <th>작성자</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{data.yangsicName}</td>
                <td>{data.yangsicRegName}</td>
              </tr>
            </tbody>
            <thead>
              <tr>
                <th colSpan={2}>파일설명[기타]</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colSpan={2}>{data.yangsicDesc}</td>
              </tr>
            </tbody>
          </Table>
          <button
            className={`btn btn-white ${stylesCoup.deleteButton}`}
            onClick={(e) => onDownload(e, parseInt(data.yangsicId))}
          >
            <i
              className={`fa-regular fa-floppy-disk ${stylesCoup.deletIcon}`}
            // style={{ marginTop: '0px', fontSize: '16px', color: 'blue' }}
            ></i>
          </button>
        </div>
      </div>
    ),
    [onDownload]
  );

  return (
    <Container fluid="fluid" className={stylesCoup.empContainerSerche}>
      <div className="row">
        <div className={`col-md-12 ${stylesCoup.empDamun}`}>
          <Button color="warning" className={stylesCoup.btn}
            onClick={() => { history.goBack(); }}
          // onClick={() => { history.push('/'); }}
          // onClick={() => {
          //   window.location.href = '/home/index';
          // }}
          >
            나가기
          </Button>
          <div
            className={`container-fluid p-5 mt-1 bg-info text-white ${stylesCoup.empHidden}`}
            style={{ textAlign: 'center' }}
          >
            <h1>양식파일조회</h1>
            <p className="lead">검색 [빈값 Enter는 전체조회].</p>
          </div>
        </div>
        <div className="col-md-12">
          <div className={`row ${stylesCoup.empList}`}>
            <div className={`col-10 ${stylesCoup.empLi00}`} >양식파일리스트</div>
            <div className={`col-2 ${stylesCoup.empLi01}`}>
              <InputGroup size="sm">
                <Input
                  className={stylesCoup.empPlSerche}
                  placeholder="검색"
                  name="yangsicNameChange"
                  value={yangsicNameChange}
                  onChange={handleInputYangsicNameChange}
                  onKeyUp={handleInputYangsicNameEnter}
                  onClick={() => {
                    setYangsicNameChange('');
                  }}
                />
                <Button
                  size="sm"
                  color="success"
                  style={{ marginRight: '4px' }}
                  onClick={handleInputYangsicNameChangeQuary}
                >
                  <i className="fa-solid fa-magnifying-glass" />
                </Button>
              </InputGroup>
            </div>
          </div>
          {Math.ceil(yangsicList.length) !== 0 ? (
            <table>
              <tbody className={stylesCoup.empTbody}>
                {[...Array(Math.ceil(yangsicList.length / 3))].map((e, i) => {
                  return (
                    <tr key={i}>
                      <td>{yangsicImageCard(yangsicList[3 * i])}</td>
                      <td>
                        {yangsicList[3 * i + 1]
                          ? yangsicImageCard(yangsicList[3 * i + 1])
                          : null}
                      </td>
                      <td>
                        {yangsicList[3 * i + 2]
                          ? yangsicImageCard(yangsicList[3 * i + 2])
                          : null}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          ) : (
            <div className={stylesCoup.empContainermessage01}>
              <div className={stylesCoup.empContainermessage02}>
                <p>검색된 자료가 없습니다.</p>
              </div>
            </div>
          )}
        </div>
      </div>
      {/* 비디오재생모달 */}
      {yangsicDetailTrue === true ? (
        <YangsicDetail
          yangsicDetailTrue={yangsicDetailTrue}
          setYangsicDetailTrue={setYangsicDetailTrue}
          yangsicValue={yangsicValue}
        />
      ) : null}
    </Container>
  );
}

export default YangsicListSerche;
